import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from 'components';
import { routes } from './config';
import { StaticPage1 } from 'pages';

const AppRouter = () => {
  return (
    <BrowserRouter basename={process.env.REACT_APP_FLOWABLE_CONTEXT_PATH}>
      <Routes>
        {/* A route with the Layout component */}
        {/* In the layout component we do all the calls to the backend */}
        <Route path="/" element={<StaticPage1 />} />
        <Route element={<Layout />}>
          {/* Mapping over the routes defined in the config file to create a Route for each one */}
          {routes.map(({ path, requireAuth, Element }, index) => (
            <Route key={index} path={path} element={<Element />} />
          ))}
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
